import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ContactPhoneRoundedIcon from '@mui/icons-material/ContactPhoneRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import LocalHospitalRoundedIcon from '@mui/icons-material/LocalHospitalRounded';
import MedicationRoundedIcon from '@mui/icons-material/MedicationRounded';
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import ScienceRoundedIcon from '@mui/icons-material/ScienceRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import WorkspacesRoundedIcon from '@mui/icons-material/WorkspacesRounded';

export const companyInfo = {
  name: 'SCIO COSMECEUTICALS LLP',
  tagline: 'PCD Pharma Franchise',
  shortDescription:
    'Premium cosmeceutical roots, franchise-ready pharma execution, and a partner-first model built for measured growth.',
  phone: '9993934794',
  email: 'sciocosmeceuticalsllp@gmail.com',
  address: '07, In Front of Government Girls school, Agra Road Depalpur, Indore, MP, India. 453115',
  whatsapp: '+919993934794',
  enquiryLabel: 'Franchise Enquiry',
  sidebarCtaLabel: 'WhatsApp Support',
  footerCopyright: 'All rights reserved.',
  socialLinks: {
    linkedin: 'https://www.linkedin.com/',
    email: 'sciocosmeceuticalsllp@gmail.com',
  },
};

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Products', path: '/products' },
  { label: 'Franchise', path: '/franchise' },
  { label: 'Export', path: '/export' },
  { label: 'Blog', path: '/blog' },
];

export const sidebarLinks = [
  { label: 'Home', path: '/', icon: HomeRoundedIcon },
  { label: 'About Us', path: '/about', icon: InfoRoundedIcon },
  { label: 'Products', path: '/products', icon: MedicationRoundedIcon },
  { label: 'PCD Franchise', path: '/franchise', icon: WorkspacesRoundedIcon },
  { label: 'Export', path: '/export', icon: PublicRoundedIcon },
  { label: 'Certifications', path: '/certifications', icon: VerifiedRoundedIcon },
  { label: 'Team', path: '/team', icon: BadgeRoundedIcon },
  { label: 'FAQ', path: '/faq', icon: ForumRoundedIcon },
  { label: 'Blog', path: '/blog', icon: NewspaperRoundedIcon },
  { label: 'Contact', path: '/contact', icon: ContactPhoneRoundedIcon },
];

export const companyStats = [
  { value: 'WHO-GMP', label: 'Approved Partners' },
  { value: 'PAN India', label: 'Distribution Reach' },
  { value: '100+', label: 'Products' },
];

export const highlightStats = [
  { value: '15+', label: 'Years Experience' },
  { value: '6', label: 'Ranges' },
  { value: '100+', label: 'Products' },
  { value: 'PAN India', label: 'Presence' },
];

export const productRanges = [
  {
    id: 'general',
    slug: 'general-range',
    filterLabel: 'General',
    label: 'General Range',
    name: 'General Range',
    description: 'Everyday essential medicines for common ailments and routine care needs.',
    assetFolderName: 'generalRange',
    icon: MedicationRoundedIcon,
    color: '#6d3fd1',
    accent: '#efe7ff',
    products: [
      {
        filename: 'Coldscio-Plus.png',
        name: 'Coldscio Plus',
        description: 'A general range formulation positioned for cold, congestion, and seasonal discomfort support.',
      },
      {
        filename: 'Fescio-XT.PNG',
        name: 'Fescio XT',
        description: 'An iron and nutritional support product for routine wellness and deficiency-focused demand.',
      },
      {
        filename: 'IMG_2503.png',
        name: 'Coughscio-BR',
        description: 'A general care product from the SCIO portfolio for everyday franchise coverage.',
      },
      {
        filename: 'IMG_2507.png',
        name: 'Coughscio-DX',
        description: 'A broad general range product designed to support fast-moving routine care needs.',
      },
      {
        filename: 'calscio-xt.png',
        name: 'Calscio XT',
        description: 'A calcium and nutrition support product for routine wellness and bone-health focused demand.',
      },
      {
        filename: 'fesciogold.jpeg',
        name: 'Fescio Gold',
        description: 'A nutritional support formulation positioned for daily wellness and supplement-focused coverage.',
      },
      {
        filename: 'montscio-lc.png',
        name: 'Montscio LC',
        description: 'A respiratory support product suited for allergy, cold, and seasonal care demand.',
      },
      {
        filename: 'scioclav-625.png',
        name: 'Scioclav 625',
        description: 'A general care antibiotic product designed for dependable day-to-day franchise demand.',
      },
      {
        filename: 'sciodol-sp box.png',
        name: 'Sciodol SP',
        description: 'A pain and inflammation support product for broad general-range market coverage.',
      },
      {
        filename: 'sciodoxime-200.png',
        name: 'Sciodoxime 200',
        description: 'A general range anti-infective product suited for routine prescription demand.',
      },
      {
        filename: 'sciofexime-200.png',
        name: 'Sciofexime 200',
        description: 'A general care formulation for anti-infective portfolio strength and repeat market need.',
      },
      {
        filename: 'scioflora.png',
        name: 'Scioflora',
        description: 'A gut-health and probiotic support product for everyday wellness portfolio coverage.',
      },
    ],
  },
  {
    id: 'diabetic',
    slug: 'diabetic',
    filterLabel: 'Diabetic',
    label: 'Diabetic Range',
    name: 'Diabetic Range',
    description: 'Sugar control and metabolic support formulations for chronic care demand.',
    assetFolderName: 'diabetic',
    icon: HealthAndSafetyRoundedIcon,
    color: '#2a7c88',
    accent: '#dcf8ff',
    products: [
      {
        filename: 'besciomine.png',
        name: 'Besciomine',
        description: 'A diabetic range product for metabolic wellness and ongoing sugar-care portfolio coverage.',
      },
      {
        filename: 'M1SR.png',
        name: 'M1 SR',
        description: 'A sustained-release diabetic care product for routine chronic therapy demand.',
      },
      {
        filename: 'M2sr.png',
        name: 'M2 SR',
        description: 'A diabetic support formulation suited for franchise portfolios focused on repeat demand.',
      },
    ],
  },
  {
    id: 'cardio',
    slug: 'cardio',
    filterLabel: 'Cardio',
    label: 'Cardio Range',
    name: 'Cardio Range',
    description: 'Heart health and blood pressure management formulations for cardiac care markets.',
    assetFolderName: 'cardio',
    icon: FavoriteRoundedIcon,
    color: '#c6456e',
    accent: '#ffe6ef',
    products: [
      {
        filename: 'am40.png',
        name: 'AM 40',
        description: 'A cardiac care product positioned for blood pressure management portfolio needs.',
      },
      {
        filename: 'rosescio20CARDIAO.png',
        name: 'Rosescio 20',
        description: 'A cardio range formulation for cholesterol and heart-health focused demand.',
      },
      {
        filename: 'rosescioCARDIAO.png',
        name: 'Rosescio',
        description: 'A cardiac product for dependable chronic care portfolio coverage.',
      },
      {
        filename: 'Telscio40.png',
        name: 'Telscio 40',
        description: 'A blood pressure management product for cardiac franchise demand.',
      },
      {
        filename: 'Ticascio90.png',
        name: 'Ticascio 90',
        description: 'A cardiac range formulation for specialist heart-care portfolios.',
      },
    ],
  },
  {
    id: 'gastrology',
    slug: 'gastrology',
    filterLabel: 'Gastrology',
    label: 'Gastrology Range',
    name: 'Gastrology Range',
    description: 'Digestive care and gastrointestinal tract solutions for complete relief.',
    assetFolderName: 'gastrology',
    icon: LocalHospitalRoundedIcon,
    color: '#d57d2f',
    accent: '#fff1e3',
    products: [
      {
        filename: 'penscio.png',
        name: 'Penscio',
        description: 'A gastrology product for acid control and digestive care portfolio needs.',
      },
      {
        filename: 'Rabscio-dsrGASTROLOGY.png',
        name: 'Rabscio DSR',
        description: 'A gastro range product for reflux, acidity, and digestive discomfort support.',
      },
      {
        filename: 'scio-sof1t.png',
        name: 'Scio Soft',
        description: 'A digestive wellness product suited for routine gastrointestinal care demand.',
      },
      {
        filename: 'scio-soft.png',
        name: 'Scio Soft',
        description: 'A gastrology formulation for digestive comfort and regular portfolio coverage.',
      },
      {
        filename: 'sioraft.png',
        name: 'Sioraft',
        description: 'A gastro care product positioned for acidity and reflux support.',
      },
    ],
  },
  {
    id: 'neurology',
    slug: 'neurology',
    filterLabel: 'Neurology',
    label: 'Neurology Range',
    name: 'Neurology Range',
    description: 'Neurology-focused formulations for specialist and chronic care distribution.',
    assetFolderName: 'neurology',
    icon: ScienceRoundedIcon,
    color: '#4451b8',
    accent: '#e8ebff',
    products: [
      {
        filename: 'levitiracetam.png',
        name: 'Levitiracetam',
        description: 'A neurology product for seizure-management focused specialist portfolio demand.',
      },
    ],
  },
];

export const certifications = [
  {
    name: 'WHO-GMP Approved',
    description: 'Manufacturing partners aligned with globally trusted quality systems.',
    icon: EmojiEventsRoundedIcon,
  },
  {
    name: 'ISO 9001:2015',
    description: 'Process-driven operations with emphasis on consistency and compliance.',
    icon: VerifiedRoundedIcon,
  },
  {
    name: 'DCGI Approved',
    description: 'Product portfolio built around approved and market-ready formulations.',
    icon: ScienceRoundedIcon,
  },
  {
    name: 'GMP Certified Manufacturing',
    description: 'Reliable production ecosystems designed for scale and safety.',
    icon: HealthAndSafetyRoundedIcon,
  },
];

export const teamMembers = [
  {
    name: 'Mr. Gourav Goud ',
    role: 'Founder / CEO',
    bio: 'Leads SCIO with a long-term view on ethical growth, quality, and partner trust.',
    initials: 'GG',
    email: 'sciocosmeceuticalsllp@gmail.com',
    linkedin: 'https://www.linkedin.com/',
  },
    {
    name: 'Mr. Shubham Makwana ',
    role: 'Co-founder ',
    bio: 'Leads SCIO with a long-term view on ethical growth, quality, and partner trust.',
    initials: 'SM',
    email: 'Shubhammakwanashubham@gmail.com',
    linkedin: 'https://www.linkedin.com/',
  },
  {
    name: 'Mr.Pratik Tiwari ',
    role: 'Head of Operations',
    bio: 'Drives execution across supply, dispatch coordination, and service reliability.',
    initials: 'PT',
    email: 'sciocosmeceuticalsllp@gmail.com',
    linkedin: 'https://www.linkedin.com/',
  },
  {
    name: 'Dr. Sunil Nakum',
    role: 'Medical Advisor',
    bio: 'Supports portfolio strategy with practical therapeutic and clinical insight.',
    initials: 'SN',
    email: 'sciocosmeceuticalsllp@gmail.com',
    linkedin: 'https://www.linkedin.com/',
  },
  {
    name: 'Mr. Raj Thakur',
    role: 'Franchise Manager',
    bio: 'Helps channel partners onboard quickly and grow with structured support.',
    initials: 'RT',
    email: 'sciocosmeceuticalsllp@gmail.com',
    linkedin: 'https://www.linkedin.com/',
  },
];

export const faqs = [
  {
    question: 'What is PCD Pharma Franchise?',
    answer:
      'A PCD Pharma Franchise model allows distributors or entrepreneurs to market and sell a company’s products in a defined territory with support on branding, supply, and product access.',
  },
  {
    question: 'What are the investment requirements to partner with SCIO?',
    answer:
      'Investment depends on your target territory and launch range, but SCIO is positioned to support scalable starting plans for both new and experienced franchise associates.',
  },
  {
    question: 'Do you provide monopoly rights?',
    answer:
      'Yes. Subject to product scope and territory availability, SCIO supports monopoly-based partnerships to help distributors build focused local markets.',
  },
  {
    question: 'What product ranges does SCIO offer?',
    answer:
      'SCIO currently focuses on general medicines, diabetic care, cardio care, gastrology products, and neurology-focused formulations.',
  },
  {
    question: 'Are your manufacturing partners WHO-GMP certified?',
    answer:
      'Yes. SCIO’s operating model is built around certified manufacturing partners aligned with WHO-GMP and GMP quality expectations.',
  },
  {
    question: 'What marketing support do you provide to franchise partners?',
    answer:
      'Partners receive guidance on product presentation, promotional material support, launch coordination, and ongoing business assistance tailored to their range and market.',
  },
  {
    question: 'What is the order and delivery process?',
    answer:
      'After requirement confirmation, product planning, and documentation, our team coordinates dispatch timelines and ongoing fulfilment updates with franchise partners.',
  },
  {
    question: 'Which territories does SCIO cover?',
    answer:
      'SCIO is structured for PAN India franchise expansion, subject to territory availability and the chosen product portfolio.',
  },
];

export const franchiseBenefits = [
  {
    title: 'Monopoly Rights',
    description: 'Territory-focused partnerships designed to reduce channel overlap.',
    icon: ShieldRoundedIcon,
  },
  {
    title: 'Marketing Support',
    description: 'Promotional guidance and launch support to help local market activation.',
    icon: CampaignRoundedIcon,
  },
  {
    title: 'WHO-GMP Products',
    description: 'Quality-aligned manufacturing partnerships that support market confidence.',
    icon: VerifiedRoundedIcon,
  },
  {
    title: 'Attractive Margins',
    description: 'Commercial structures designed for practical, sustainable channel growth.',
    icon: PaidRoundedIcon,
  },
];

export const whyUs = [
  {
    title: 'WHO-GMP Partners',
    description: 'A quality-driven ecosystem that supports reliability across categories.',
    icon: VerifiedRoundedIcon,
  },
  {
    title: 'Ethical PCD Model',
    description: 'Built around transparent relationships and steady partner enablement.',
    icon: CheckCircleRoundedIcon,
  },
  {
    title: 'Monopoly Rights',
    description: 'Territory discipline that helps partners grow with confidence.',
    icon: ShieldRoundedIcon,
  },
];

export const strengthChips = [
  'WHO-GMP',
  'Ethical PCD',
  'Monopoly Rights',
  'Marketing Support',
  'Quality Assured',
];

export const aboutValues = [
  {
    title: 'Vision',
    description: 'Expand a trusted pharma franchise network built on quality, access, and long-term distributor value.',
    icon: InsightsRoundedIcon,
  },
  {
    title: 'Quality Discipline',
    description: 'Work only with manufacturing systems that reinforce product confidence and compliance expectations.',
    icon: VerifiedRoundedIcon,
  },
  {
    title: 'Partner Support',
    description: 'Help franchise associates launch faster and scale with structured commercial guidance.',
    icon: SupportAgentRoundedIcon,
  },
];

export const franchiseSteps = [
  {
    title: 'Apply',
    description: 'Share your territory, product interest, and distribution goals with our franchise team.',
  },
  {
    title: 'Approval',
    description: 'We align on range scope, territory availability, and onboarding requirements.',
  },
  {
    title: 'Launch',
    description: 'Start with coordinated supply, support material, and a clear market rollout plan.',
  },
];

export const partners = [
  'Aurum Labs',
  'Veritas Pharma',
  'CoreMed India',
  'Helios Remedies',
  'Zenica Life',
  'BioNova Care',
];

export const exportReadiness = [
  { label: 'Product Categories', value: 'Pharma + Cosmeceuticals' },
  { label: 'Certification', value: 'WHO-GMP & COPP Ready' },
  { label: 'Order Quantity', value: 'Flexible MOQ' },
  { label: 'Shipping', value: 'Worldwide on Request' },
];

export const exportStats = [
  { value: '100+', label: 'Export-Ready Products' },
  { value: 'WHO-GMP', label: '& COPP Certified' },
  { value: 'Open', label: 'For Enquiries Worldwide' },
];

export const exportWhyCards = [
  {
    title: 'Combined Pharma & Cosmeceutical Range',
    description:
      'A single export partner for both pharmaceutical formulations and cosmeceutical products, across general, diabetic and cardio ranges.',
    icon: InventoryRoundedIcon,
  },
  {
    title: 'Regulatory-Ready Dossiers',
    description:
      'COPP, Free Sale Certificates, GMP and product dossiers prepared on request for faster customs and registration.',
    icon: FactCheckRoundedIcon,
  },
];

export const exportProcessSteps = [
  {
    title: 'Enquiry & Product Selection',
    description: 'Share your target market and required product ranges.',
  },
  {
    title: 'Regulatory Documentation',
    description: 'We prepare COPP, GMP and country-specific paperwork.',
  },
  {
    title: 'Order & Manufacturing',
    description: 'Production scheduled with your partner manufacturer.',
  },
  {
    title: 'Shipping & Compliance',
    description: 'Freight, customs and delivery tracked end to end.',
  },
];

export const exportRegions = [
  'Africa',
  'Middle East',
  'CIS Region',
  'Southeast Asia',
  'South Asia',
  'Latin America',
];

export const exportCtaChecklist = [
  { title: 'Now open to new export partners worldwide', icon: PublicRoundedIcon },
  { title: 'WHO-GMP certified manufacturing partners', icon: VerifiedRoundedIcon },
  { title: 'Dedicated export relationship manager', icon: SupportAgentRoundedIcon },
];

export const exportProductInterestOptions = ['Pharma Range', 'Cosmeceutical Range', 'Both'];

export const blogPosts = [
  {
    slug: 'pcd-franchise-growth-playbook',
    title: 'Building A Stronger PCD Franchise Growth Playbook',
    category: 'Franchise Tips',
    date: 'May 12, 2026',
    author: 'SCIO Editorial',
    excerpt: 'A practical look at how new distributors can approach territory planning, range selection, and partner support.',
    content: [
      'A successful PCD franchise strategy starts with territory discipline and a realistic understanding of how local demand develops over time.',
      'The strongest early moves typically combine one dependable therapeutic basket, consistent stock visibility, and a clear doctor-and-retailer outreach plan.',
      'Franchise partners also benefit when the parent company supports them with practical material, responsive coordination, and steady product availability.',
      'SCIO’s approach is built around helping partners grow in a structured way rather than pushing volume without operational alignment.',
    ],
  },
  {
    slug: 'who-gmp-partnerships-and-market-trust',
    title: 'Why WHO-GMP Partnerships Matter In Market Trust',
    category: 'Industry News',
    date: 'May 3, 2026',
    author: 'SCIO Editorial',
    excerpt: 'Quality benchmarks influence confidence at every stage of a pharma franchise relationship.',
    content: [
      'WHO-GMP alignment is more than a label. It shapes how distributors evaluate consistency, compliance confidence, and long-term viability.',
      'When franchise partners know the manufacturing backbone is credible, commercial conversations become easier and more defensible.',
      'That is especially important when expanding into markets where product reliability and repeat demand are closely linked.',
      'SCIO continues to position quality-backed partnerships as a central part of its operating model.',
    ],
  },
  {
    slug: 'expanding-demand-for-nutraceutical-ranges',
    title: 'Expanding Demand For Nutraceutical And Wellness Ranges',
    category: 'Product Updates',
    date: 'April 26, 2026',
    author: 'SCIO Editorial',
    excerpt: 'Preventive healthcare demand continues to create room for strong nutraceutical portfolios.',
    content: [
      'Nutraceutical and wellness categories remain important because they connect clinical relevance with repeat consumer usage.',
      'Distributors often find that these products support relationship-building across both retail and practitioner channels.',
      'A focused portfolio with clean positioning can make the category easier to scale without unnecessary complexity.',
      'SCIO sees this segment as an important complement to core therapeutic distribution.',
    ],
  },
  {
    slug: 'how-to-select-your-first-product-range',
    title: 'How To Select Your First Product Range As A Franchise Partner',
    category: 'Franchise Tips',
    date: 'April 18, 2026',
    author: 'SCIO Editorial',
    excerpt: 'Range selection should be based on market clarity, not just the size of the catalog.',
    content: [
      'New franchise partners often perform better when they begin with a range that matches known local demand and prescriber familiarity.',
      'The right first basket should support confident detailing, manageable inventory planning, and repeat order behaviour.',
      'This makes execution simpler and improves focus during the early launch period.',
      'SCIO advises partners to balance commercial opportunity with local operating realism.',
    ],
  },
  {
    slug: 'cardiac-and-diabetic-care-opportunities',
    title: 'Cardiac And Diabetic Care Continue To Offer Strong Opportunities',
    category: 'Industry News',
    date: 'April 8, 2026',
    author: 'SCIO Editorial',
    excerpt: 'Chronic care portfolios remain essential to sustained demand across many territories.',
    content: [
      'Cardiac and diabetic products sit inside a demand pattern driven by ongoing care and long-term therapy continuity.',
      'For distributors, that makes the category commercially significant when backed by dependable supply and strong positioning.',
      'The opportunity is strongest when the portfolio is curated rather than excessively broad.',
      'SCIO continues to see this range as central to sustainable franchise planning.',
    ],
  },
  {
    slug: 'launching-franchise-territories-with-clarity',
    title: 'Launching New Franchise Territories With More Clarity',
    category: 'Product Updates',
    date: 'March 29, 2026',
    author: 'SCIO Editorial',
    excerpt: 'Better launch planning reduces friction for both the partner and the supply side.',
    content: [
      'Territory launches work best when onboarding, documentation, product planning, and first dispatch preparation move in sync.',
      'A fragmented launch creates avoidable delays and uncertainty in the market.',
      'Structured rollout planning improves confidence for everyone involved and creates a stronger base for repeat business.',
      'SCIO emphasizes launch clarity as part of its partner support model.',
    ],
  },
];

export const pageContent = {
  home: {
    heroChip: 'WHO-GMP Certified Partners',
    heroTitle: 'India’s Premier Cosmeceutical & Pharma Franchise',
    heroDescription:
      'SCIO brings a legacy in cosmeceuticals into a full-scale pharma PCD franchise model with dependable manufacturing partners, a wide product basket, and expansion-ready support across India.',
    heroPrimaryCta: { label: 'Explore Products', path: '/products' },
    heroSecondaryCta: { label: 'Become a Partner', path: '/franchise' },
    whySection: {
      eyebrow: 'Why Choose SCIO',
      title: 'Built For Serious Franchise Growth',
      subtitle:
        'A quality-led model shaped for distributors who want dependable support, focused ranges, and scalable partnerships.',
    },
    previewSection: {
      eyebrow: 'Featured Ranges',
      title: 'Core Product Categories Ready For Distribution',
      subtitle:
        'SCIO covers practical, fast-moving categories designed for franchise relevance across markets.',
      cta: { label: 'View All', path: '/products' },
    },
    bottomCta: {
      title: 'Ready to build your next pharma distribution territory with SCIO?',
      subtitle:
        'Start the conversation with a team focused on product quality, partner support, and territory-led growth.',
      buttonLabel: 'Explore Franchise Opportunity',
      path: '/franchise',
    },
  },
  about: {
    banner: {
      title: 'About Us',
      subtitle: 'A trusted cosmeceutical foundation now expanding into a broader pharma franchise network.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'About Us', path: '/about' },
      ],
    },
    missionTitle: 'A premium partner-first growth model.',
    missionDescription:
      'SCIO has built its identity around effective healthcare positioning, product understanding, and channel trust. That same foundation now drives a wider pharma franchise offering for distributors who need quality, support, and territory focus.',
    story: [
      'SCIO’s story begins with cosmeceutical depth, market understanding, and a commitment to clear product positioning.',
      'Over time, that experience created a practical understanding of what distributors need from a supply partner: quality confidence, responsive coordination, and a range structure that fits real demand.',
      'Today, SCIO is translating that expertise into a broader pharmaceutical presence with carefully chosen manufacturing partnerships and a disciplined PCD franchise model.',
    ],
    valuesSection: {
      eyebrow: 'Vision & Values',
      title: 'The operating principles behind SCIO',
      subtitle:
        'Growth matters, but it has to be built on quality systems, disciplined execution, and responsible partner support.',
    },
  },
  products: {
    banner: {
      title: 'Our Product Ranges',
      subtitle: 'Focused therapeutic and wellness categories for practical franchise expansion.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'Products', path: '/products' },
      ],
    },
    heading: {
      eyebrow: 'Product Portfolio',
      title: 'Explore SCIO’s distribution-ready ranges',
      subtitle:
        'Filter the portfolio by category and connect with us for product interest or franchise discussions.',
    },
    filterLabels: ['All', 'General', 'Diabetic', 'Cardio', 'Gastrology', 'Neurology'],
    enquireButton: 'View Products',
    downloadButton: 'Download Product List',
  },
  franchise: {
    banner: {
      title: 'PCD Franchise Opportunity',
      subtitle: 'A structured onboarding path for distributors looking to grow with a quality-led pharma partner.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'PCD Franchise', path: '/franchise' },
      ],
    },
    stepsSection: {
      eyebrow: 'How It Works',
      title: 'A simple path from enquiry to market launch',
      subtitle:
        'SCIO keeps the onboarding process clear so franchise partners can move from discussion to execution without avoidable friction.',
    },
    benefitsSection: {
      eyebrow: 'Why Partner',
      title: 'Commercial and operational advantages',
      subtitle:
        'Our franchise model is designed to support both launch confidence and ongoing market development.',
    },
    formSection: {
      title: 'Franchise Enquiry Form',
      successMessage: 'Your franchise enquiry has been submitted successfully.',
      errorMessage: 'We could not submit your franchise enquiry right now. Please try again.',
      fields: [
        { name: 'name', label: 'Name', required: true },
        { name: 'phone', label: 'Phone', required: true },
        { name: 'city', label: 'City', required: true },
        { name: 'state', label: 'State', required: true },
        { name: 'message', label: 'Message', required: false, multiline: true, rows: 4 },
      ],
      rangeLabel: 'Interested Range',
      submitLabel: 'Submit Franchise Enquiry',
      submittingLabel: 'Submitting...',
    },
  },
  export: {
    hero: {
      eyebrow: 'WHO-GMP Certified · Now Open for Export',
      title: 'Now Open for Global Pharma & Cosmeceutical Export',
      description:
        'SCIO is opening its full pharma and cosmeceutical range to international partners, distributors and importers — backed by regulatory-ready documentation and WHO-GMP certified manufacturing.',
      primaryCta: { label: 'Start Export Enquiry' },
      secondaryCta: { label: 'Download Export Catalogue' },
      readinessTitle: 'Export Readiness',
      readinessSubtitle: 'What international partners can expect from SCIO.',
    },
    whySection: {
      eyebrow: 'Why Export With SCIO',
      title: 'Built for international pharma & cosmeceutical partners',
      subtitle:
        'A single, quality-led source for both categories, with documentation support designed to shorten your registration timeline.',
    },
    processSection: {
      eyebrow: 'Export Process',
      title: 'A clear path from enquiry to delivery',
      subtitle:
        'SCIO keeps international onboarding structured, so partners can move from first contact to shipment with confidence.',
    },
    regionsSection: {
      title: "Regions We're Open to Export To",
      subtitle:
        "SCIO welcomes export enquiries from importers and distributors across these regions.",
    },
    ctaBanner: {
      title: "Ready to Bring SCIO's Pharma & Cosmeceutical Range Into Your Country?",
      buttonLabel: 'Submit Export Enquiry',
    },
    formSection: {
      title: 'Export Enquiry Form',
      subtitle: 'Tell us about your market and product interest, and our export team will follow up.',
      successMessage: 'Your export enquiry has been submitted successfully.',
      errorMessage: 'We could not submit your export enquiry right now. Please try again.',
      fields: [
        { name: 'name', label: 'Full Name', required: true },
        { name: 'company', label: 'Company Name', required: true },
        { name: 'country', label: 'Country', required: true },
        { name: 'email', label: 'Email', required: true, type: 'email' },
        { name: 'phone', label: 'Phone (with country code)', required: true },
        { name: 'message', label: 'Message', required: false, multiline: true, rows: 4 },
      ],
      productInterestLabel: 'Product Interest',
      submitLabel: 'Submit Export Enquiry',
      submittingLabel: 'Submitting...',
    },
  },
  certificationsPage: {
    banner: {
      title: 'Our Certifications',
      subtitle: 'Quality and compliance signals that reinforce confidence in the SCIO operating model.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'Certifications', path: '/certifications' },
      ],
    },
    heading: {
      eyebrow: 'Compliance & Trust',
      title: 'Certification-backed positioning for stronger partnerships',
      subtitle:
        'SCIO’s network is built around manufacturing and product standards that support commercial credibility.',
    },
    partnersLabel: 'Trusted Manufacturing Partners',
  },
  teamPage: {
    banner: {
      title: 'Meet Our Team',
      subtitle: 'The people shaping product direction, partner support, and operational execution.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'Team', path: '/team' },
      ],
    },
    heading: {
      eyebrow: 'Leadership Team',
      title: 'A lean team with clear operating ownership',
      subtitle:
        'SCIO combines leadership, operations, medical perspective, and franchise support into one focused team.',
    },
  },
  faqPage: {
    banner: {
      title: 'Frequently Asked Questions',
      subtitle: 'Answers to the questions most often raised by prospective franchise partners.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'FAQ', path: '/faq' },
      ],
    },
    heading: {
      eyebrow: 'FAQs',
      title: 'Clarifying how SCIO works',
      subtitle:
        'These answers cover partnership structure, territory expectations, product scope, and support.',
    },
  },
  contactPage: {
    banner: {
      title: 'Get In Touch',
      subtitle: 'Share your details and preferred range. The SCIO team will connect with you shortly.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'Contact', path: '/contact' },
      ],
    },
    heading: {
      eyebrow: 'Contact Us',
      title: 'Start your SCIO conversation',
      subtitle:
        'Whether you are evaluating a territory or a product category, we can guide the next step.',
    },
    infoCards: [
      { label: 'Location', valueKey: 'address', icon: ApartmentRoundedIcon },
      { label: 'Phone', valueKey: 'phone', icon: ContactPhoneRoundedIcon },
      { label: 'Email', valueKey: 'email', icon: SupportAgentRoundedIcon },
    ],
    whatsappBox: {
      title: 'Need a faster response?',
      description: 'Reach our franchise support desk directly on WhatsApp for a quicker introduction.',
      buttonLabel: 'Chat on WhatsApp',
    },
    form: {
      successMessage: 'Thank you! We’ll contact you shortly.',
      errorMessage: 'We could not submit your enquiry right now. Please try again.',
      submitLabel: 'Submit Enquiry',
      submittingLabel: 'Submitting...',
      fields: [
        { name: 'fullName', label: 'Name', required: true },
        { name: 'email', label: 'Email', required: true, type: 'email' },
        { name: 'phone', label: 'Phone', required: true },
        { name: 'city', label: 'City', required: true },
        { name: 'message', label: 'Message', required: false, multiline: true, rows: 5 },
      ],
      rangeLabel: 'Interested Range',
    },
  },
  blogPage: {
    banner: {
      title: 'News & Updates',
      subtitle: 'Insights across industry trends, franchise guidance, and product-focused thinking.',
      breadcrumb: [
        { label: 'Home', path: '/' },
        { label: 'Blog', path: '/blog' },
      ],
    },
    heading: {
      eyebrow: 'Blog',
      title: 'Read the latest from SCIO',
      subtitle:
        'A static editorial feed covering pharma franchise planning, quality signals, and range development.',
    },
    readMoreLabel: 'Read More',
  },
  blogDetailPage: {
    backLabel: 'Back to Blog',
    relatedHeading: 'Related Posts',
    contactBoxTitle: 'Interested in partnering with SCIO?',
    contactBoxDescription: 'Speak with our team about product ranges, territory opportunities, and franchise support.',
    contactBoxButton: 'Contact Us',
  },
};

export const footerRanges = productRanges.map((range) => range.name);

export const productSelectOptions = productRanges.map((range) => range.name);

export const pageActions = {
  enquirePath: '/contact',
  downloadLabel: 'Download Product List',
  viewAllProductsPath: '/products',
  franchisePath: '/franchise',
  exportPath: '/export',
  contactPath: '/contact',
  blogPath: '/blog',
  whatsappPath: `https://wa.me/${companyInfo.whatsapp.replace(/\D/g, '')}`,
  callPath: `tel:${companyInfo.phone.replace(/\s/g, '')}`,
};

export const homePreviewRangeIds = ['general', 'diabetic', 'cardio'];

export const homeBottomBenefits = [
  {
    title: 'Quality-Backed Products',
    description: 'Built around credible manufacturing partnerships and range discipline.',
    icon: VerifiedRoundedIcon,
  },
  {
    title: 'Franchise-Focused Support',
    description: 'Structured help from onboarding through ongoing execution.',
    icon: SupportAgentRoundedIcon,
  },
  {
    title: 'Market-Ready Portfolio',
    description: 'Products selected for practical demand across multiple territories.',
    icon: InventoryRoundedIcon,
  },
];

export const sharedLabels = {
  activeUnderline: 'active',
  relatedPosts: 'Related Posts',
  viewAll: 'View All',
  home: 'Home',
  learnMore: 'Learn More',
  submit: 'Submit',
  by: 'By',
  date: 'Date',
  author: 'Author',
  ctaReadMore: 'Read More',
  ctaEnquire: 'Enquire Now',
  ctaDownload: 'Download Product List',
  ctaWhatsapp: 'WhatsApp',
  ctaCall: 'Call',
  sidebarContactHeading: 'Quick Contact',
};

export const contactQuickInfo = [
  { label: 'Phone', value: companyInfo.phone },
  { label: 'Email', value: companyInfo.email },
];

export const pageBannerHomeLink = { label: 'Home', path: '/' };

export const blogDetailFallback = {
  title: 'Post Not Found',
  subtitle: 'The requested article could not be found.',
};

export const pageDecor = {
  heroChipIcon: ArrowForwardRoundedIcon,
};
